import { useEffect, useRef, useState } from "react";
import Globe from "react-globe.gl";

// Lightweight curated arcs connecting tech hubs — matches existing rotating globe
const ARCS = [
  { startLat: 12.97, startLng: 77.59, endLat: 40.71, endLng: -74.0 }, // BLR -> NYC
  { startLat: 12.97, startLng: 77.59, endLat: 51.51, endLng: -0.13 }, // BLR -> LON
  { startLat: 12.97, startLng: 77.59, endLat: 35.68, endLng: 139.69 }, // BLR -> TYO
  { startLat: 12.97, startLng: 77.59, endLat: 25.2, endLng: 55.27 }, // BLR -> DXB
  { startLat: 12.97, startLng: 77.59, endLat: -33.86, endLng: 151.2 }, // BLR -> SYD
  { startLat: 12.97, startLng: 77.59, endLat: 1.35, endLng: 103.81 }, // BLR -> SGP
  { startLat: 40.71, startLng: -74.0, endLat: 37.77, endLng: -122.41 }, // NYC -> SF
  { startLat: 51.51, startLng: -0.13, endLat: 48.85, endLng: 2.35 }, // LON -> PAR
  { startLat: 25.2, startLng: 55.27, endLat: -1.29, endLng: 36.82 }, // DXB -> NBO
];

const POINTS = [
  { lat: 14.46, lng: 75.92, size: 1.2, color: "#3B82F6", label: "ZeroLabs HQ — Davangere" },
  { lat: 12.97, lng: 77.59, size: 0.9, color: "#3B82F6", label: "Bangalore" },
  { lat: 40.71, lng: -74.0, size: 0.6, color: "#22D3EE", label: "New York" },
  { lat: 51.51, lng: -0.13, size: 0.6, color: "#22D3EE", label: "London" },
  { lat: 35.68, lng: 139.69, size: 0.6, color: "#22D3EE", label: "Tokyo" },
  { lat: 25.2, lng: 55.27, size: 0.6, color: "#22D3EE", label: "Dubai" },
  { lat: -33.86, lng: 151.2, size: 0.5, color: "#22D3EE", label: "Sydney" },
  { lat: 1.35, lng: 103.81, size: 0.5, color: "#22D3EE", label: "Singapore" },
  { lat: 37.77, lng: -122.41, size: 0.5, color: "#22D3EE", label: "San Francisco" },
  { lat: 48.85, lng: 2.35, size: 0.5, color: "#22D3EE", label: "Paris" },
  { lat: -1.29, lng: 36.82, size: 0.5, color: "#22D3EE", label: "Nairobi" },
];

export default function GlobeHero({ height = 560 }) {
  const ref = useRef();
  const wrapRef = useRef();
  const [width, setWidth] = useState(560);

  useEffect(() => {
    if (!wrapRef.current) return;
    const ro = new ResizeObserver(([entry]) => {
      setWidth(Math.max(280, entry.contentRect.width));
    });
    ro.observe(wrapRef.current);
    return () => ro.disconnect();
  }, []);

  useEffect(() => {
    if (!ref.current) return;
    const controls = ref.current.controls();
    if (controls) {
      controls.autoRotate = true;
      controls.autoRotateSpeed = 0.7;
      controls.enableZoom = false;
    }
    ref.current.pointOfView({ lat: 14, lng: 76, altitude: 2.0 }, 0);
  }, []);

  return (
    <div
      ref={wrapRef}
      data-testid="hero-globe"
      className="relative w-full"
      style={{ height }}
    >
      <Globe
        ref={ref}
        width={width}
        height={height}
        backgroundColor="rgba(0,0,0,0)"
        showAtmosphere
        atmosphereColor="#22D3EE"
        atmosphereAltitude={0.22}
        globeImageUrl="//unpkg.com/three-globe/example/img/earth-dark.jpg"
        bumpImageUrl="//unpkg.com/three-globe/example/img/earth-topology.png"
        pointsData={POINTS}
        pointLat="lat"
        pointLng="lng"
        pointAltitude={0.02}
        pointRadius="size"
        pointColor="color"
        pointLabel={(d) => `<div style="background:#08060F;border:1px solid rgba(0,229,255,.4);padding:6px 10px;border-radius:8px;font-family:'IBM Plex Sans',sans-serif;color:#fff;font-size:12px">${d.label}</div>`}
        arcsData={ARCS}
        arcStartLat="startLat"
        arcStartLng="startLng"
        arcEndLat="endLat"
        arcEndLng="endLng"
        arcColor={() => ["rgba(245,166,35,0.0)", "rgba(245,166,35,0.9)", "rgba(0,229,255,0.0)"]}
        arcDashLength={0.5}
        arcDashGap={1.5}
        arcDashAnimateTime={3500}
        arcStroke={0.4}
      />
      {/* soft vignette overlay */}
      <div className="pointer-events-none absolute inset-0" style={{
        background: "radial-gradient(circle at 50% 50%, transparent 55%, #08060F 100%)"
      }} />
    </div>
  );
}
